const enUS = require('./en-US.json');

export default {
  'en-US': enUS
};
